import React from "react";

export default class JsonFile extends React.Component {
  static get MenuData() {
    return [
      { id: 1, name: "خانه", link: "/" },
      { id: 2, name: "شروع ماجراجویی", link: "/home" },
      { id: 3, name: "از کتابنو چه خبر؟", link: "/blog/keta-blog" },
    ];
  }
  static get giftData() {
    return [
      {
        id: 1,
        count: 3,
        src: "imgs/Landing/laptop.png",
        Description: "لپ تاپ 15 اینچی",
      },
      {
        id: 2,
        count: 3,
        src: "imgs/Landing/camera.png",
        Description: "دوربین سوپر زوم کنون",
      },
      {
        id: 3,
        count: 3,
        src: "imgs/Landing/mobile.png",
        Description: "گوشی A5 سامسونگ",
      },
      {
        id: 4,
        count: 3,
        src: "imgs/Landing/watch.png",
        Description: "ساعت هوشمند شیائومی",
      },
      {
        id: 5,
        count: 3,
        src: "imgs/Landing/headset.png",
        Description: "هدست بلوتوثی",
      },
      {
        id: 6,
        count: 3,
        src: "imgs/Landing/powerbank.png",
        Description: "پاوربانک شیائومی",
      },
    ];
  }
  static get pieceOfBook() {
    return [
      {
        id: 1,
        src: "imgs/Landing/book1.png",
        name: "از کتاب اول",
        Description:
          'پرتغالی‌ها هر کدوم از نقاط سواحل غربی آفریقا رو بعد از گرفتن از دست بومی‌ها، به اسم کالایی که از اونجا به‌دست میاوردن نام‌گذاری می‌کردن. واسه همین مثلا ساحلی که با کشتار فیل‌ها، عاج فراوانی به‌دست میومد و از فروشش سود زیادی می‌بردن رو صدا زدن "ساحلِ عاج!"',
      },
      {
        id: 2,
        src: "imgs/Landing/book2.png",
        name: "از کتاب دوم",
        Description:
          "ملکه‌ی انگلستان -الیزابت- کل اروپا رو مسخره‌ی خودش کرده بود و با معطل‌نگهداشتن خواستگارهای دربارهای مختلف، سیاست کشورش رو تامین می‌کرد. به شاهزاده‌ی فرانسه بعد از ۱۰ سال جواب منفی داد. چون اگه سریع می‌گفت نه، شاهزاده‌هه می‌رفت با دختر پادشاه اسپانیا ازدواج می‌کرد و اونا قوی می‌شدن، می‌تونستن جاهایی که انگلیس می‌خواست غارت کنه رو غارت کنن!",
      },
      {
        id: 3,
        src: "imgs/Landing/book3.png",
        name: "از کتاب سوم",
        Description:
          "وقتی چیزی به اسم «بیمه» به‌وجود اومد، یه بحث فلسفی توی اروپا شکل گرفت: اینکه آیا برده‌ها انسانن یا جزو اجناس به‌حساب میان؟ آیا اونها شامل بیمه‌ی انسان میشن یا یه‌نوع جنس‌ان؟ یه عده می‌‌گفتن اونا روح دارن پس انسانن و یه عده می‌گفتن اوان معامله میشن پس جنسن!",
      },
      {
        id: 4,
        src: "imgs/Landing/book4.png",
        name: "از کتاب چهارم",
        Description:
          "همه‌ سرخپوست‌ها در هنریکو مجبور بودند روزی دو بار به کلیسا بروند. اگر سرخپوستی فقط یکبار فراموش می‌کرد که به کلیسا برود، برای یک هفته به او غذا نمی‌دادند. اگر دو بار نمی‌رفت شلاق می‌خورد و اگر ترک کلیسا چند بار اتفاق می‌افتاد، با شلیک گلوله کشته می‌شد.",
      },
      {
        id: 5,
        src: "imgs/Landing/book5.png",
        name: "از کتاب پنجم",
        Description:
          "هنگامی که آخرین نفرات سرخپوست‌ها در ساحل شرقی پیاده می‌شدند؛ جریانِ آرام می‌سی‌سی‌پی، اجساد منجمد افراد قبیله را دورتر و دورتر می‌برد.",
      },
      {
        id: 6,
        src: "imgs/Landing/book6.png",
        name: "از کتاب ششم",
        Description:
          "در مهمان‌خانه‌های پاریس دربرابر پول، هر غذایی را برای شما آماده می‌کنند. اگر هوس کنی گوشت کباب‌شده‌ی ققنوس را بخوری -پرنده‌ای افسانه‌ای که در آتش می‌سوزد و دوباره از خاکسترش برمی‌خیزد- دربرابر بیست و پنج سکه، برایت آماده می‌کنند.",
      },
      {
        id: 7,
        src: "imgs/Landing/book7.png",
        name: "از کتاب هفتم",
        Description:
          "الماسی به‌وزن ۱۸۶ قیراط که هیچ‌کس نمی‌دانست نخستین صاحب آن کیست، چه‌کسی آن را یافته و کدام هنرمند آن را تراش داده است. الماسی که بین پادشاهان مختلف و کشورهای هندوستان، ایران و افغانستان دست‌به‌دست شده بود و اکنون در چنگ انگلیسی‌ها بود. داستان رسیدن الماس به‌دست انگلیسی‌ها، شگفت‌انگیز و باورنکردنی است...",
      },
      {
        id: 8,
        src: "imgs/Landing/book1.png",
        name: "از کتاب هشتم",
        Description:
          "خبرنگار ناگهان چهره‌ او را به‌خاطر آورد و دهانش از تعجب باز ماند. او یکی از حاکمان محلی بود که یک روز پیش، با جامه‌ها و آرایشی باشکوه دربرابر او حاضر شده بود. دستبند طلا به‌دست داشت، چند رشته مروارید به دستارش دوخته شده بود و شمشیر جواهرنشان بزرگی به کمر بسته بود؛ اما امروز مثل یک خدمتکار لباس پوشیده بود. ",
      },
      {
        id: 9,
        src: "imgs/Landing/book2.png",
        name: "از کتاب نهم",
        Description:
          "باربرهایی که صندوق های چوبی محمدرضا بیگ، سفیر ایران در فرانسه، را به کشتی می‌بردند، برای حمل جعبه‌ بزرگی که سوراخ‌هایی روی آن بود به دردسر افتاده بودند. محمدرضا بیگ می‌گفت کتاب‌های موردعلاقه‌اش را در این جعبه قرار داده است؛ اما وقتی جناب سفیردر اتاقش، درِ جعبه را بااحتیاط باز کرد، خانم مارکیز اپینی -که سفیر با او در فرانسه ازدواج کرده بود- از جعبه بیرون آمد!",
      },
      {
        id: 10,
        src: "imgs/Landing/book3.png",
        name: "از کتاب دهم",
        Description:
          "شاه‌تهماسب پس از هشت‌ سال دوباره به قصر وارد شد. پیرزنی که لباس خدمتکارها را به‌تن داشت به‌سوی او دوید و او را غرق بوسه کرد. تهماسب در چشم‌های خیس پیرزن خیره شد و سرانجام در چشم‌های بی‌رمق او نگاه مادرش را شناخت! مادر شاه‌تهماسب، ملکه ایران، هنگام هجوم افغان‌ها لباس خدمتکارها را پوشیده بود تا جان خود را نجات دهد!",
      },
      {
        id: 11,
        src: "imgs/Landing/book4.png",
        name: "از کتاب یازدهم",
        Description:
          "شاهی که یافتن قافیه‌های مناسب برای شعرهایی که درباره طوطی و نوش‌آفرین (معشوقه‌هایش) می‌سرود، بیشتر وقتش را گرفته بود، فرصت نداشت اخبار جهان را دنبال کند، تحولات سیاسی اروپا را پیگیری کند و جنگ‌ها و دوستی‌ و دشمنی‌های آن‌ قاره را زیرنظر بگیرد.",
      },
      {
        id: 12,
        src: "imgs/Landing/book5.png",
        name: "از کتاب دوازدهم",
        Description:
          "دختر در رویا دیده بود پدرش درحالی‌که تاجی را در دست دارد از خانه بیرون می‌رود. از پدرش می‌پرسد: «این تاج را کجا می‌برید؟» پدر جواب می‌دهد: «تاج محمدعلی‌شاه است. می‌روم روی سر او بگذارم.» دختر متوجه می‌شود که تاج را از برف ساخته‌اند. دلیل آن را می‌پرسد. پدر جواب می‌دهد: «برای مدتی که روی تخت شاهی می‌ماند، کافی است!» ",
      },
      {
        id: 13,
        src: "imgs/Landing/book6.png",
        name: "از کتاب سیزدهم",
        Description:
          "آمریکایی‌ها، زمین‌شناس برجسته‌ای را به‌نام دوگولیر به عربستان فرستادند. عرب‌ها رسم داشتند که از میهمانانشان با چشم گوسفند پذیرایی کنند. دوگولیر چشم‌های گوسفند را با اشتها خورد و بعد، با چشم باز به جستجوی نفت عربستان رفت!",
      },
      {
        id: 14,
        src: "imgs/Landing/book7.png",
        name: "از کتاب چهاردهم",
        Description:
          "سیاه‌ها در آغاز باید باور می‌کردند که سفیدپوست‌ها متمدن و بافرهنگ هستند. آن‌ها حتی به‌خاطر چهره زشتشان باید از سفیدها خجالت می‌کشیدند. در مجله‌ها و تابلوهای گوشه‌وکنار شهرها و روستاها، یک انسان سفید با موهای بور و چشم‌های آبی دیده می‌شد. سفید شدن، به بزرگ‌ترین آرزوی سیاهان تبدیل شده بود.",
      },
      {
        id: 15,
        src: "imgs/Landing/book1.png",
        name: "از کتاب پانزدهم",
        Description:
          "بهره‌برداری دیوانه‌های طلا، تا پایان قرن، نقطه جستجونشده‌ای را باقی نگذاشته بود. طلایی که به‌دست می‌آمد روزبه‌روز کمتر می‌شد تا اینکه پرتغالی‌ها بالاخره از یافتن طلای بیشتر ناامید شدند و برزیل را برای صادر کردن یک محصول دیگر درنظر گرفتند: قهوه!",
      },
    ];
  }
  static get introduce() {
    return [
      { id: 1, src: "imgs/Landing/imageName.png", name: "poster" },
      { id: 2, src: "imgs/Landing/imageName.png", name: "teaser" },
      { id: 3, src: "imgs/Landing/imageName.png", name: "infographic" },
      { id: 4, src: "imgs/Landing/imageName.png", name: "motion" },
    ];
  }
  static get socialedia() {
    return [
      {
        id: 1,
        src: "imgs/Landing/telegram-icon.svg",
        name: "telegram",
        label: "تلگرام",
        url: "",
      },
      {
        id: 2,
        src: "imgs/Landing/Aparat-icon.svg",
        name: "aparat",
        label: "آپارات",
        url: "",
      },
      {
        id: 3,
        src: "imgs/Landing/instagram-icon.svg",
        name: "instagram",
        label: "اینستاگرام",
        url: "",
      },
      {
        id: 4,
        src: "imgs/Landing/Youtube-icon.svg",
        name: "youtube",
        label: "یوتیوب",
        url: "",
      },
      {
        id: 5,
        src: "imgs/Landing/Twitter-icon.svg",
        name: "twitter",
        label: "توییتر",
        url: "",
      },
    ];
  }
  static get statistics() {
    return {
      instagram: "37000",
      history: "9000",
      reflects: "24000",
      readBook: "83000",
      readTime: "59000",
    };
  }
  static get FAQ() {
    return [
      {
        id: 1,
        title: "پویش هیس‌طوری چیه؟",
        content:
          "پویش هیس‌طوری متفاوت‌ترین و جذاب‌ترین پویش کتابخوانی نوجوانانه کشوره با کلی جایزه باحال و جذاب!",
      },
      {
        id: 2,
        title: "چه جوری تو پویش هیس‌طوری ثبت‌نام کنیم؟",
        content:
          "همین که تو این سایت هستید، یعنی 90 درصد راه رو درست اومدید! ادامه‌اش اینه که وقت خرید کتاب، شماره موبایل‌تون رو ثبت کنید و بعد هم برای انجام آزمون، پروفایل‌تون رو کامل کنید.",
      },
      {
        id: 3,
        title: "شرایط شرکت تو پویش چیه؟",
        content:
          "شرکت تو این پویش هیچ شرطی نداره جز شرط سنی! جوایز این پویش مخصوص نوجوان‌های 13 تا 18 ساله است، یعنی دانش‌آموزای متوسطه اول و متوسطه دوم. دختر و پسر. البته خریدن و خوندن کتاب‌ها برای همه آزاده!",
      },
      {
        id: 4,
        title: "تو پویش هیس‌طوری باید چی کارا بکنیم؟",
        content:
          "15 تا کتاب بخونید، 15 تا آزمون بامزه رو پشت سر بذارید، 15 تا کنش هنرمندانه انجام بدید و 15 تا نظر کارشناسی بدید! همین!!",
      },
      {
        id: 5,
        title: "پویش هیس‌طوری از کی شروع میشه و تا کی ادامه داره؟",
        content:
          "شروع پویش دقیقا همون روزیه که شما همت کنید و شروع کنید به خوندن کتاب اول! پایان پویش هم شروع دهه فجر یعنی 12 بهمنه. اعلام برنده‌‌ها و اهدای جوایز هم تو اختتامیه پویش که 22 بهمن برگزار میشه، انجام میشه.",
      },
      {
        id: 6,
        title: "جایزه‌ها چی هستند؟ به کیا داده میشن؟",
        content:
          "خوبه خوبه! حتما بعدشم می‌خوای بپرسی سکه و امتیاز و مدال چه جوری بگیرم؟! قرار نیست همه چی رو ما بگیم که! سه تا موشن‌گرافیک خوشکل و تر و تمیز آماده کردیم که جواب باقی سوالاتت توشون هست! ببین‌شون و اگه بازم سوالی مونده بود، تو بخش پشتیبانی ازمون بپرس!",
      },
    ];
  }
  static get media() {
    return [
      {
        id: 1,
        name: "fars",
        src: "imgs/Landing/farsnews.png",
        link: "link.com",
        label: "خبر گزاری فارس",
      },
      {
        id: 2,
        name: "irib",
        src: "imgs/Landing/irib.png",
        link: "link.com",
        label: "خبر گزاری صدا و سیما",
      },
      {
        id: 3,
        name: "pana",
        src: "imgs/Landing/pana.png",
        link: "link.com",
        label: "خبر گزاری پانا",
      },
      {
        id: 4,
        name: "tasnim",
        src: "imgs/Landing/tasnim.png",
        link: "link.com",
        label: "خبر گزاری تسنیم",
      },
      {
        id: 5,
        name: "mehr",
        src: "imgs/Landing/mehrnews.png",
        link: "link.com",
        label: "خبر گزاری مهر",
      },
      {
        id: 1,
        name: "fars",
        src: "imgs/Landing/farsnews.png",
        link: "link.com",
        label: "خبر گزاری فارس",
      },
      {
        id: 2,
        name: "irib",
        src: "imgs/Landing/irib.png",
        link: "link.com",
        label: "خبر گزاری صدا و سیما",
      },
    ];
  }
  static get Supporters() {
    return [
      {
        id: 1,
        name: "صدا وسیما",
        src: "imgs/Landing/sedasima.png",
        link: "#",
        label: "صدا و سیما",
      },
      // {
      //     id: 2,
      //     name: "حوره هنری",
      //     src: "imgs/Landing/hozehonari.svg",
      //     link: "#",
      //     label: "حوزه هنری سازمان تبلیغات ",
      // },
      {
        id: 3,
        name: "سازمان دانش آموزی",
        src: "imgs/Landing/daneshamoozi.svg",
        link: "#",
        label: "سازمان دانش آموزی",
      },
      {
        id: 4,
        name: "وزارت فرهنگ و ارشاد",
        src: "imgs/Landing/ershad.svg",
        link: "#",
        label: "وزارت فرهنگ و ارشاد اسلامی",
      },
      {
        id: 5,
        name: "انجمن اسلامی",
        src: "imgs/Landing/anjoman.svg",
        link: "#",
        label: "اتحادیه انجمن های اسلامی دانش آموزان",
      },
      {
        id: 6,
        name: "شهرداری تهران",
        src: "imgs/Landing/shahrdari.svg",
        link: "#",
        label: "شهرداری تهران",
      },
      {
        id: 7,
        name: "آموزش و پرورش",
        src: "imgs/Landing/amozeshparvaresh.svg",
        link: "#",
        label: "وزارت آموزش و پرورش",
      },
      {
        id: 8,
        name: "بسیج دانش آموزی",
        src: "imgs/Landing/basij.svg",
        link: "#",
        label: "بسیج دانش آموزی",
      },
      {
        id: 1,
        name: "صدا وسیما",
        src: "imgs/Landing/sedasima.png",
        link: "#",
        label: "صدا و سیما",
      },
      // {
      //     id: 2,
      //     name: "حوره هنری",
      //     src: "imgs/Landing/hozehonari.png",
      //     link: "#",
      //     label: "حوزه هنری سازمان تبلیغات ",
      // },
      {
        id: 3,
        name: "سازمان دانش آموزی",
        src: "imgs/Landing/daneshamoozi.svg",
        link: "#",
        label: "سازمان دانش آموزی",
      },
      {
        id: 4,
        name: "وزارت فرهنگ و ارشاد",
        src: "imgs/Landing/ershad.svg",
        link: "#",
        label: "وزارت فرهنگ و ارشاد اسلامی",
      },
      {
        id: 5,
        name: "انجمن اسلامی",
        src: "imgs/Landing/anjoman.svg",
        link: "#",
        label: "اتحادیه انجمن های اسلامی دانش آموزان",
      },
      {
        id: 6,
        name: "شهرداری تهران",
        src: "imgs/Landing/shahrdari.svg",
        link: "#",
        label: "شهرداری تهران",
      },
      {
        id: 7,
        name: "آموزش و پرورش",
        src: "imgs/Landing/amozeshparvaresh.svg",
        link: "#",
        label: "وزارت آموزش و پرورش",
      },
      {
        id: 8,
        name: "بسیج دانش آموزی",
        src: "imgs/Landing/basij.svg",
        link: "#",
        label: "بسیج دانش آموزی",
      },
    ];
  }
  static get comrade() {
    return [
      {
        id: 1,
        name: "سوره مهر",
        src: "imgs/Landing/soremehr.png",
        link: "#",
        label: "سوره مهر",
      },
      // {
      //     id: 1,
      //     name: "اسنپ",
      //     src: "imgs/Landing/snap.png",
      //     link: "#",
      //     label: "اسنپ",
      // },
      {
        id: 1,
        name: "مهرک",
        src: "imgs/Landing/mehrak.png",
        link: "#",
        label: "مهرک",
      },
      // {
      //     id: 1,
      //     name: "دیجی کالا",
      //     src: "imgs/Landing/digikala.png",
      //     link: "#",
      //     label: "دیجی کالا",
      // },
      {
        id: 1,
        name: "طاقچه",
        src: "imgs/Landing/taghche.png",
        link: "#",
        label: "طاقچه",
      },
    ];
  }
  static get siteSetting() {
    return {
      phone: "02166746528 - 02166747914",
      email: "info@ketabno.com",
      address:
        "تهران، خیابان جمهوری اسلامی، خیابان حافط، کوچه هاتف، سازمان دانش‌آموزی وزارت آموزش و پرورش",
    };
  }
  static get MainMenu() {
    return [
      {
        id: 1,
        icon: (active) => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              opacity="0.5"
              d="M25.2448 6.7456L17.1888 1.10296C14.993 -0.437213 11.6224 -0.353203 9.51049 1.28498L2.5035 6.7596C1.1049 7.85172 0 10.092 0 11.8562V21.5173C0 25.0877 2.8951 28 6.46154 28H21.5385C25.1049 28 28 25.1017 28 21.5313V12.0382C28 10.148 26.7832 7.82372 25.2448 6.7456Z"
              fill={active ? "#01CBFB" : "white"}
            />
            <path
              d="M13.9943 23.4501C13.4208 23.4501 12.9453 22.9741 12.9453 22.4V18.1995C12.9453 17.6255 13.4208 17.1494 13.9943 17.1494C14.5677 17.1494 15.0432 17.6255 15.0432 18.1995V22.4C15.0432 22.9741 14.5677 23.4501 13.9943 23.4501Z"
              fill={active ? "#01CBFB" : "white"}
            />
          </svg>
        ),
        title: "خانه",
        link: "/hisstori/home",
      },
      {
        id: 2,
        icon: (active) => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="26"
            viewBox="0 0 23 26"
            fill="none"
          >
            <path
              d="M12.4004 9.8002H19.6004V8.8626C19.6005 8.64076 19.5698 8.41998 19.5092 8.2066L19.5076 8.2002C19.3952 7.8096 19.1854 7.45395 18.898 7.1666L12.634 0.902595C12.1841 0.452966 11.5741 0.200331 10.938 0.200195H3.60039C2.7517 0.200195 1.93777 0.537337 1.33765 1.13745C0.737532 1.73757 0.400391 2.5515 0.400391 3.4002V22.6002C0.400391 23.4489 0.737532 24.2628 1.33765 24.8629C1.93777 25.4631 2.7517 25.8002 3.60039 25.8002H7.15399L7.13319 25.7586C6.88401 25.2787 6.7706 24.7398 6.80519 24.2002H3.60039C3.17604 24.2002 2.76908 24.0316 2.46902 23.7316C2.16896 23.4315 2.00039 23.0245 2.00039 22.6002V3.4002C2.00039 2.97585 2.16896 2.56888 2.46902 2.26882C2.76908 1.96877 3.17604 1.8002 3.60039 1.8002H10.0004V7.4002C10.0004 8.03672 10.2532 8.64716 10.7033 9.09725C11.1534 9.54734 11.7639 9.8002 12.4004 9.8002ZM12.4004 8.2002C12.1882 8.2002 11.9847 8.11591 11.8347 7.96588C11.6847 7.81585 11.6004 7.61237 11.6004 7.4002V2.1314L17.6692 8.2002H12.4004ZM17.6964 12.277C17.9735 11.9957 18.3035 11.772 18.6675 11.6188C19.0314 11.4657 19.4221 11.3861 19.817 11.3846C20.2118 11.3832 20.6031 11.4599 20.9681 11.6104C21.3332 11.7608 21.6649 11.9821 21.944 12.2613C22.2232 12.5406 22.4443 12.8724 22.5947 13.2375C22.745 13.6026 22.8216 13.9939 22.82 14.3888C22.8184 14.7836 22.7386 15.1743 22.5853 15.5382C22.432 15.9021 22.2082 16.232 21.9268 16.509L14.1988 24.2354C13.7486 24.6858 13.1845 25.0054 12.5668 25.1602L10.17 25.7586C9.93167 25.818 9.68203 25.8147 9.44534 25.7491C9.20865 25.6835 8.99295 25.5578 8.8192 25.3842C8.64544 25.2107 8.51954 24.9951 8.45373 24.7584C8.38791 24.5218 8.38442 24.2722 8.44359 24.0338L9.04359 21.637C9.19705 21.0188 9.51688 20.4543 9.96839 20.005L17.6964 12.277Z"
              fill={active ? "#01CBFB" : "#EDEDED"}
            />
          </svg>
        ),
        title: "بلاگ",
        link: "/hisstori/blog",
      },
      {
        id: 3,
        icon: (active) => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="27"
            viewBox="0 0 30 27"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.5349 20.8912C16.6134 21.8723 16.6888 22.8142 16.6984 23.4429C17.4623 23.7655 19.2726 24.6159 20.2801 25.5747C18.4425 25.7596 9.90865 25.5491 8.92342 25.3836C10.1857 24.6244 11.626 23.9322 13.0158 23.4575C12.993 22.3242 13.0623 21.2559 13.1359 20.1228C13.194 19.2272 13.2547 18.2911 13.2747 17.2503C13.1357 17.2242 12.9061 17.1644 12.6789 17.1052C12.4663 17.0499 12.2558 16.995 12.1235 16.9689C10.4732 16.6423 9.27063 15.7276 8.40175 14.5396C7.21984 15.0594 5.74416 14.4354 4.77312 13.7677C2.73487 12.3663 0.0226495 9.55661 1.35326 6.85565C2.14742 5.24367 4.76008 4.73511 6.3624 4.66364C6.45136 3.91265 6.65166 3.18206 7.11767 2.69477C7.96258 1.81122 9.41568 1.44077 10.5777 1.27239C13.1613 0.898026 15.8051 0.863594 18.3696 1.46131C18.4317 1.47565 18.4974 1.49067 18.5664 1.50643C19.7197 1.77005 21.7853 2.2422 23.0513 3.24658C23.3391 3.49555 23.5698 3.78132 23.7172 4.1113C23.8491 4.40643 23.9254 4.97485 23.9281 5.7157C24.1355 5.77219 24.3604 5.82824 24.5963 5.88702C26.1385 6.27132 28.1498 6.77247 28.7841 8.27921C29.3866 9.71003 28.6228 11.0657 27.7859 12.1935C26.2214 14.3018 23.2788 17.0083 20.4014 15.5711C19.8946 16.0485 19.3238 16.4407 18.6834 16.7159C18.0419 16.9916 17.2175 17.2166 16.3564 17.3271C16.3124 18.1111 16.4266 19.5385 16.5349 20.8912ZM3.51822 6.66442C1.27637 7.44898 2.8027 10.728 4.07957 11.7387C4.46775 12.046 4.88056 12.3242 5.30053 12.5855C5.79192 12.8912 6.89278 13.3014 7.4908 13.0745C7.20356 12.4226 6.9849 11.7004 6.77941 10.983C6.35356 9.49633 6.16061 7.84767 6.10026 6.29799C5.2298 6.25972 4.34534 6.37492 3.51822 6.66442ZM27.3032 9.95764C26.3473 12.3138 24.1109 14.579 21.3705 14.3095C22.5722 12.1941 23.7681 9.65487 24.0492 7.22146C24.1224 7.23719 24.1963 7.25169 24.2703 7.26621C24.4464 7.30076 24.6234 7.33548 24.7939 7.38735C25.894 7.72216 27.9459 8.3736 27.3032 9.95764Z"
              stroke={active ? "#01CBFB" : "white"}
              strokeMiterlimit="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        title: "باشگاه",
        link: "/hisstori/club",
      },
      {
        id: 5,
        icon: (active) => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="29"
            viewBox="0 0 22 29"
            fill="none"
          >
            <path
              d="M10.987 14.2784C10.9434 14.2784 10.9143 14.2784 10.8707 14.2784C10.7981 14.2653 10.6964 14.2653 10.6092 14.2784C6.39519 14.1601 3.21289 11.1629 3.21289 7.46903C3.21289 3.7094 6.59862 0.646484 10.7545 0.646484C14.9104 0.646484 18.2961 3.7094 18.2961 7.46903C18.2816 11.1629 15.0847 14.1601 11.0306 14.2784C11.0161 14.2784 11.0015 14.2784 10.987 14.2784ZM10.7545 2.61832C7.8047 2.61832 5.39255 4.80048 5.39255 7.46903C5.39255 10.0981 7.65939 12.2146 10.5511 12.3066C10.6237 12.2935 10.8272 12.2935 11.0161 12.3066C13.8641 12.1883 16.1019 10.0719 16.1164 7.46903C16.1164 4.80048 13.7043 2.61832 10.7545 2.61832Z"
              fill={active ? "#01CBFB" : "#EDEDED"}
            />
            <path
              d="M11 28.5718C8.15192 28.5718 5.2893 27.9145 3.12417 26.5999C1.10436 25.3905 0 23.7342 0 21.9333C0 20.1323 1.10436 18.4628 3.12417 17.2403C7.48349 14.6243 14.5456 14.6243 18.8758 17.2403C20.8811 18.4497 22 20.106 22 21.907C22 23.7079 20.8956 25.3774 18.8758 26.5999C16.6962 27.9145 13.8481 28.5718 11 28.5718ZM4.33025 18.8966C2.93527 19.738 2.17966 20.8159 2.17966 21.9464C2.17966 23.0638 2.9498 24.1417 4.33025 24.9699C7.94848 27.1652 14.0515 27.1652 17.6697 24.9699C19.0647 24.1286 19.8203 23.0506 19.8203 21.9201C19.8203 20.8027 19.0502 19.7248 17.6697 18.8966C14.0515 16.7145 7.94848 16.7145 4.33025 18.8966Z"
              fill={active ? "#01CBFB" : "#EDEDED"}
            />
          </svg>
        ),
        title: "پروفایل",
        link: "/profile",
      },
    ];
  }
  static get SafiranMenuJson() {
    return [
      {
        id: 1,
        icon: (active) => (
          <svg
            width="26"
            height="28"
            viewBox="0 0 26 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.3946 27H4.3083C3.89902 27 3.49378 26.9191 3.11586 26.762C2.73793 26.605 2.39477 26.3747 2.10609 26.0846C1.81741 25.7945 1.58891 25.4502 1.4337 25.0715C1.2785 24.6928 1.19965 24.2871 1.2017 23.8779V9.30791C1.2017 8.81344 1.43469 8.35781 1.82302 8.0588L11.8936 1.42362C12.162 1.22096 12.4892 1.11133 12.8256 1.11133C13.1619 1.11133 13.4891 1.22096 13.7575 1.42362L23.8799 8.0588C24.2682 8.35781 24.5012 8.81344 24.5012 9.30791V23.8779C24.5033 24.2871 24.4244 24.6928 24.2692 25.0715C24.114 25.4502 23.8855 25.7945 23.5968 26.0846C23.3081 26.3747 22.965 26.605 22.587 26.762C22.2091 26.9191 21.8039 27 21.3946 27Z"
              stroke={active ? "#01CBFB" : "white"}
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M10.0036 14.0557H15.699C16.2685 14.0557 16.7345 14.5217 16.7345 15.0912V26.9998H8.96802V15.0912C8.96802 14.5217 9.43401 14.0557 10.0036 14.0557Z"
              stroke={active ? "#01CBFB" : "white"}
              stroke-width="2"
              stroke-miterlimit="10"
            />
          </svg>
        ),
        title: "خانه",
        link: "/hisstori/safiran",
      },
      {
        id: 2,
        icon: (active) => (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="29"
            viewBox="0 0 22 29"
            fill="none"
          >
            <path
              d="M10.987 14.2784C10.9434 14.2784 10.9143 14.2784 10.8707 14.2784C10.7981 14.2653 10.6964 14.2653 10.6092 14.2784C6.39519 14.1601 3.21289 11.1629 3.21289 7.46903C3.21289 3.7094 6.59862 0.646484 10.7545 0.646484C14.9104 0.646484 18.2961 3.7094 18.2961 7.46903C18.2816 11.1629 15.0847 14.1601 11.0306 14.2784C11.0161 14.2784 11.0015 14.2784 10.987 14.2784ZM10.7545 2.61832C7.8047 2.61832 5.39255 4.80048 5.39255 7.46903C5.39255 10.0981 7.65939 12.2146 10.5511 12.3066C10.6237 12.2935 10.8272 12.2935 11.0161 12.3066C13.8641 12.1883 16.1019 10.0719 16.1164 7.46903C16.1164 4.80048 13.7043 2.61832 10.7545 2.61832Z"
              fill={active ? "#01CBFB" : "#EDEDED"}
            />
            <path
              d="M11 28.5718C8.15192 28.5718 5.2893 27.9145 3.12417 26.5999C1.10436 25.3905 0 23.7342 0 21.9333C0 20.1323 1.10436 18.4628 3.12417 17.2403C7.48349 14.6243 14.5456 14.6243 18.8758 17.2403C20.8811 18.4497 22 20.106 22 21.907C22 23.7079 20.8956 25.3774 18.8758 26.5999C16.6962 27.9145 13.8481 28.5718 11 28.5718ZM4.33025 18.8966C2.93527 19.738 2.17966 20.8159 2.17966 21.9464C2.17966 23.0638 2.9498 24.1417 4.33025 24.9699C7.94848 27.1652 14.0515 27.1652 17.6697 24.9699C19.0647 24.1286 19.8203 23.0506 19.8203 21.9201C19.8203 20.8027 19.0502 19.7248 17.6697 18.8966C14.0515 16.7145 7.94848 16.7145 4.33025 18.8966Z"
              fill={active ? "#01CBFB" : "#EDEDED"}
            />
          </svg>
        ),
        title: "حساب کاربری",
        link: "/account-safiran",
      },
      {
        id: 3,
        icon: (active) => (
          <svg
            width="27"
            height="28"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.6667 1.53418H4.33333C3.44928 1.53418 2.60143 1.88537 1.97631 2.51049C1.35119 3.13561 1 3.98346 1 4.86751V23.2008C1 24.0849 1.35119 24.9327 1.97631 25.5579C2.60143 26.183 3.44928 26.5342 4.33333 26.5342H22.6667C23.5507 26.5342 24.3986 26.183 25.0237 25.5579C25.6488 24.9327 26 24.0849 26 23.2008V4.86751C26 3.98346 25.6488 3.13561 25.0237 2.51049C24.3986 1.88537 23.5507 1.53418 22.6667 1.53418Z"
              stroke={active ? "#01CBFB" : "#EDEDED"}
              stroke-width="2"
              stroke-miterlimit="10"
            />
            <path
              d="M7.94458 15.4227L12.1112 19.5894L19.0557 9.86719"
              stroke={active ? "#01CBFB" : "#EDEDED"}
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
        title: "کانال سفیران",
        link: "https://eitaa.com/safiran_hisstori",
      },
    ];
  }
  static get Introduce() {
    return {
      img: "/imgs/Blog/intfoduce-img.png",
      content: `
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
            `,
    };
  }
  static get Alerts() {
    return [
      {
        id: 1,
        title: "اطلاعیه شماره یک",
        date: "11/10/2022",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 2,
        title: "اطلاعیه شماره دو",
        date: "11/10/2022",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 3,
        title: "اطلاعیه شماره سه",
        date: "11/10/2022",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
    ];
  }
  static get News() {
    return [
      {
        id: 1,
        title: "شروع پویش جدید",
        date: "11/10/2022",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 2,
        title: "تغییر جوایز",
        date: "11/10/2022",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 3,
        title: "اعلام برندگان",
        date: "11/10/2022",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 4,
        title: "معرفی در کافه بازار",
        date: "11/10/2022",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
    ];
  }
  static get KetaBlog() {
    return [
      {
        id: 1,
        title: "کتابنو چیست؟",
        img: null,
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 2,
        title: "چطور در پویش شرکت کنم؟",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصدلورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد   لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد      `,
      },
    ];
  }
  static get TermsAndConditions() {
    return [
      {
        id: 1,
        title: "قانون اول",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 2,
        title: "قانون دوم",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 3,
        title: "قانون سوم",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 4,
        title: "قانون چهارم",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
    ];
  }
  static get TermsOfUse() {
    return [
      {
        id: 1,
        title: "شرط اول",
        img: null,
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 2,
        title: "شرط دوم",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 3,
        title: "شرط سوم",
        img: null,
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 4,
        title: "شرط چهارم",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
    ];
  }
  static get Guide() {
    return [
      {
        id: 1,
        title: "چگونه ثبت نام کنیم؟",
        img: null,
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 2,
        title: "چگونه در پویش‌ها شرکت کنیم؟",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 3,
        title: "چگونه از تخفیفات استفاده کنیم؟",
        img: null,
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        id: 4,
        title: "چگونه کتاب بخریم؟",
        img: "/imgs/Blog/News-img.png",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
    ];
  }
  static get BlogSliderbottom() {
    return [
      {
        id: 1,
        src: "/imgs/ketablog/imagedata.png",
        title: "کتابنو چیست؟ کتابنو چیست؟ کتابنو چیست؟",
        name: "سارا اسماعیلی",
        date: "11 تیر 1401",
      },
      {
        id: 2,
        src: "/imgs/ketablog/imagedata.png",
        name: "سارا اسماعیلی",
        title: "کتابنو چیست؟ کتابنو چیست؟ کتابنو چیست؟",
        date: "11 تیر 1401",
      },
      {
        id: 3,
        src: "/imgs/ketablog/imagedata.png",
        title: "کتابنو چیست؟ کتابنو چیست؟ کتابنو چیست؟",
        name: "سارا اسماعیلی",
        date: "11 تیر 1401",
      },
      {
        id: 4,
        src: "/imgs/ketablog/imagedata.png",
        title: "کتابنو چیست؟ کتابنو چیست؟ کتابنو چیست؟",
        name: "سارا اسماعیلی",
        date: "11 تیر 1401",
      },
      {
        id: 5,
        src: "/imgs/ketablog/imagedata.png",
        title: "کتابنو چیست؟ کتابنو چیست؟ کتابنو چیست؟",
        name: "سارا اسماعیلی",
        date: "11 تیر 1401",
      },
      {
        id: 6,
        src: "/imgs/ketablog/imagedata.png",
        title: "کتابنو چیست؟ کتابنو چیست؟ کتابنو چیست؟",
        name: "سارا اسماعیلی",
        date: "11 تیر 1401",
      },
    ];
  }
  static get BlogSliderhotText() {
    return [
      {
        id: 1,
        src: "/imgs/ketablog/imageketabno.png",
        title: "ده کتاب برا خوانش تاریخ",
        text: "لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوملورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسومر لورم اپیسوم لورم اپیسوم لورم اپیسوم ر لورم اپیسوم",
        date: "11 تیر 1401",
      },
      {
        id: 2,
        src: "/imgs/ketablog/imageketabno.png",
        title: "ده کتاب برا خوانش تاریخ",
        text: "لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوملورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسومر لورم اپیسوم لورم اپیسوم لورم اپیسوم ر لورم اپیسوم",
        date: "11 تیر 1401",
      },
      {
        id: 3,
        src: "/imgs/ketablog/imageketabno.png",
        title: "ده کتاب برا خوانش تاریخ",
        text: "لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوملورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسومر لورم اپیسوم لورم اپیسوم لورم اپیسوم ر لورم اپیسوم",
        date: "11 تیر 1401",
      },
      {
        id: 4,
        src: "/imgs/ketablog/imageketabno.png",
        title: "ده کتاب برا خوانش تاریخ",
        text: "لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوملورم اپیسوم لورم  اپیسوم لورم اپیسوم لورم  اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسومر لورم اپیسوم لورم اپیسوم لورم اپیسوم ر لورم اپیسوم",
        date: "11 تیر 1401",
      },
      {
        id: 5,
        src: "/imgs/ketablog/imageketabno.png",
        title: "ده کتاب برا خوانش تاریخ",
        text: "لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوملورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسومر لورم اپیسوم لورم اپیسوم لورم اپیسوم ر لورم اپیسوم",
        date: "11 تیر 1401",
      },
      {
        id: 6,
        src: "/imgs/ketablog/imageketabno.png",
        title: "ده کتاب برا خوانش تاریخ",
        text: "لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسوملورم اپیسوم لورم اپیسوم لورم اپیسوم لورم اپیسومر لورم اپیسوم لورم اپیسوم لورم اپیسوم ر لورم اپیسوم",
        date: "11 تیر 1401",
      },
    ];
  }
  static get SupportQuestions() {
    return [
      {
        title: "مشکلی با خرید کتاب دارم",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        title: "مشکلی با ارسال کنش داشتم",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
      {
        title: "مشکلی با  اپلیکیشن داشتم",
        content: `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد  `,
      },
    ];
  }
}
